import { MultiLanguage } from "../common/_modals/multi-language";

export const OK_TXT: MultiLanguage = {hi: 'हाँ', en: 'Ok'};
export const CANCEL_TXT: MultiLanguage = {hi: 'नही', en: 'Cancel'};
export const CALL_CONFIRM: MultiLanguage = {hi: 'हितग्राही से कॉल कनेक्ट करनी चाहिए?', en: 'Do you want to connect to the contributor?'};
export const CALL_CONNECTING: MultiLanguage = {hi: 'कृपया इंतजार करें आपकी कॉल लाभार्थी से कनेक्ट हो रही है।', en: 'Please wait while your call connects.'};
export const CALL_FAIL: MultiLanguage = {hi: 'कॉल विफल हुआ, कृपया बाद में प्रयास करें।', en: 'Call failed, please try later'};

export function getTranslateText(lan: string, text: MultiLanguage) {
    switch(lan) {
        case 'hi': {
            return text.hi;
        }
        case 'en': {
            return text.en;
        }
    }
}